import store from 'state/store';
import { getSessionEventIntentFields } from '@pano-project/utils/eventIntent';
import { isMultiIntentSession } from '@pano-project/utils/intentMapping';
import { triggerAdvanceCashierEvent } from './trigger-advance-cashier-event';

let multiIntentLoadedEventSent = false;

// A multi-intent session sends the loaded event exactly once per page life,
// for the tab Cashier opened on: the tab switch reloads the method list, and
// the loaded event must not be repeated for the other tab. A single-intent
// session sends it exactly as today.
export const cashierLoaded = (data) => {
  const state = store.getState();
  const isMultiIntent = isMultiIntentSession(state);

  if (isMultiIntent && multiIntentLoadedEventSent) return;
  if (isMultiIntent) multiIntentLoadedEventSent = true;

  triggerAdvanceCashierEvent({
    event_type: 'cashier_loaded',
    ...data,
    ...getSessionEventIntentFields(state),
  });
};

// Test helper: forgets that the loaded event was sent.
export const resetCashierLoadedEvent = () => {
  multiIntentLoadedEventSent = false;
};
